// Nederlandse labels en badgekleuren voor de Sprekers-enums. Zelfde
// {value, label, className}-patroon als in modules/leiderschap/labels.ts.
import type {
  AvailabilityStatus, EngagementStatus, InvitationStatus, PresentationStatus, PresentationType, SlideType,
  SlideVisibility, SpeakerType,
} from './types';

interface Labeled<T extends string> {
  value: T;
  label: string;
  className: string;
}

export const ENGAGEMENT_STATUSES: Labeled<EngagementStatus>[] = [
  { value: 'uitgenodigd', label: 'Uitgenodigd', className: 'bg-slate-100 text-slate-700' },
  { value: 'bevestigd', label: 'Bevestigd', className: 'bg-teal-100 text-teal-700' },
  { value: 'in_voorbereiding', label: 'In voorbereiding', className: 'bg-amber-100 text-amber-700' },
  { value: 'concept_gereed', label: 'Concept gereed', className: 'bg-amber-100 text-amber-700' },
  { value: 'ter_beoordeling', label: 'Ter beoordeling', className: 'bg-amber-100 text-amber-700' },
  { value: 'aanpassing_gevraagd', label: 'Aanpassing gevraagd', className: 'bg-red-100 text-red-700' },
  { value: 'goedgekeurd', label: 'Goedgekeurd', className: 'bg-emerald-100 text-emerald-700' },
  { value: 'presentatie_gereed', label: 'Presentatie gereed', className: 'bg-emerald-100 text-emerald-700' },
  { value: 'technisch_getest', label: 'Technisch getest', className: 'bg-emerald-100 text-emerald-700' },
  { value: 'gereed_voor_dienst', label: 'Gereed voor dienst', className: 'bg-emerald-100 text-emerald-700' },
  { value: 'gesproken', label: 'Gesproken', className: 'bg-slate-100 text-slate-500' },
  { value: 'gearchiveerd', label: 'Gearchiveerd', className: 'bg-slate-100 text-slate-500' },
  { value: 'geannuleerd', label: 'Geannuleerd', className: 'bg-slate-100 text-slate-400' },
];

export const INVITATION_STATUSES: Labeled<InvitationStatus>[] = [
  { value: 'concept', label: 'Concept', className: 'bg-slate-100 text-slate-600' },
  { value: 'verstuurd', label: 'Verstuurd', className: 'bg-teal-100 text-teal-700' },
  { value: 'bekeken', label: 'Bekeken', className: 'bg-teal-100 text-teal-700' },
  { value: 'geaccepteerd', label: 'Geaccepteerd', className: 'bg-emerald-100 text-emerald-700' },
  { value: 'voorlopig_geaccepteerd', label: 'Voorlopig geaccepteerd', className: 'bg-amber-100 text-amber-700' },
  { value: 'afgewezen', label: 'Afgewezen', className: 'bg-red-100 text-red-700' },
  { value: 'geannuleerd', label: 'Geannuleerd', className: 'bg-slate-100 text-slate-500' },
  { value: 'verlopen', label: 'Verlopen', className: 'bg-slate-100 text-slate-500' },
];

export const AVAILABILITY_STATUSES: Labeled<AvailabilityStatus>[] = [
  { value: 'beschikbaar', label: 'Beschikbaar', className: 'bg-emerald-100 text-emerald-700' },
  { value: 'beperkt_beschikbaar', label: 'Beperkt beschikbaar', className: 'bg-amber-100 text-amber-700' },
  { value: 'niet_beschikbaar', label: 'Niet beschikbaar', className: 'bg-red-100 text-red-700' },
  { value: 'alleen_op_uitnodiging', label: 'Alleen op uitnodiging', className: 'bg-slate-100 text-slate-600' },
  { value: 'tijdelijk_niet_actief', label: 'Tijdelijk niet actief', className: 'bg-slate-100 text-slate-500' },
];

export const SPEAKER_TYPES: Labeled<SpeakerType>[] = [
  { value: 'intern', label: 'Intern', className: 'bg-slate-100 text-slate-700' },
  { value: 'extern', label: 'Extern', className: 'bg-slate-100 text-slate-700' },
];

export const PRESENTATION_TYPES: Labeled<PresentationType>[] = [
  { value: 'slides', label: 'Slides', className: 'bg-slate-100 text-slate-700' },
  { value: 'canvas', label: 'Canvas', className: 'bg-slate-100 text-slate-700' },
];

export const PRESENTATION_STATUSES: Labeled<PresentationStatus>[] = [
  { value: 'concept', label: 'Concept', className: 'bg-slate-100 text-slate-600' },
  { value: 'gereed', label: 'Gereed', className: 'bg-teal-100 text-teal-700' },
  { value: 'technisch_getest', label: 'Technisch getest', className: 'bg-emerald-100 text-emerald-700' },
  { value: 'gepubliceerd', label: 'Gepubliceerd', className: 'bg-emerald-100 text-emerald-700' },
];

export const SLIDE_TYPES: Labeled<SlideType>[] = [
  { value: 'titelslide', label: 'Titelslide', className: 'bg-slate-100 text-slate-700' },
  { value: 'bijbeltekst', label: 'Bijbeltekst', className: 'bg-slate-100 text-slate-700' },
  { value: 'verwijzing', label: 'Verwijzing', className: 'bg-slate-100 text-slate-700' },
  { value: 'kernzin', label: 'Kernzin', className: 'bg-slate-100 text-slate-700' },
  { value: 'bulletpoints', label: 'Bulletpoints', className: 'bg-slate-100 text-slate-700' },
  { value: 'citaat', label: 'Citaat', className: 'bg-slate-100 text-slate-700' },
  { value: 'afbeelding', label: 'Afbeelding', className: 'bg-slate-100 text-slate-700' },
  { value: 'video', label: 'Video', className: 'bg-slate-100 text-slate-700' },
  { value: 'audio', label: 'Audio', className: 'bg-slate-100 text-slate-700' },
  { value: 'vraag', label: 'Vraag', className: 'bg-slate-100 text-slate-700' },
  { value: 'gebedspunt', label: 'Gebedspunt', className: 'bg-slate-100 text-slate-700' },
  { value: 'responsmoment', label: 'Responsmoment', className: 'bg-slate-100 text-slate-700' },
  { value: 'zwart_scherm', label: 'Zwart scherm', className: 'bg-slate-800 text-white' },
  { value: 'afsluitslide', label: 'Afsluitslide', className: 'bg-slate-100 text-slate-700' },
  // Alleen via import of Zoea Studio aan te maken, niet via het eenvoudige slideformulier.
  { value: 'vrije_slide', label: 'Bewerkbare slide', className: 'bg-teal-100 text-teal-700' },
];

export const SLIDE_VISIBILITIES: Labeled<SlideVisibility>[] = [
  { value: 'alleen_spreker', label: 'Alleen spreker', className: 'bg-slate-100 text-slate-600' },
  { value: 'op_beamer', label: 'Op beamer tonen', className: 'bg-teal-100 text-teal-700' },
  { value: 'delen_met_worship', label: 'Delen met Worship', className: 'bg-amber-100 text-amber-700' },
  { value: 'delen_met_dienstleider', label: 'Delen met dienstleider', className: 'bg-amber-100 text-amber-700' },
  { value: 'delen_met_presentatieteam', label: 'Delen met presentatieteam', className: 'bg-amber-100 text-amber-700' },
  { value: 'openbaar_na_dienst', label: 'Openbaar na de dienst', className: 'bg-emerald-100 text-emerald-700' },
];

export function findLabel<T extends string>(options: Labeled<T>[], value: T | null | undefined): string {
  return options.find((option) => option.value === value)?.label ?? (value || '-');
}

export function findClassName<T extends string>(options: Labeled<T>[], value: T | null | undefined): string {
  return options.find((option) => option.value === value)?.className ?? 'bg-slate-100 text-slate-700';
}
